import React, { useEffect, useState } from "react";
import axios from "axios";
import BeAPartForm from "./BeAPartForm";
import SubNav from "../../Layout/SubNav";
import Benifit from "./Benifit";
import OurTeam from "./OurTeam";
import "./style.css";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";

const Career = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const career = await axios.get(
      "https://staging-cms-main.ipurvey.com/career"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([career.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="career_container">
          <div className="career_md">
            <SubNav head="Careers" />
            <BeAPartForm data={data[0]} />
            <Benifit />
            <OurTeam />
          </div>
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else return <Loader />;
};

export default Career;
